import * as React from "react";
import {Dropdown,Flag} from "semantic-ui-react";
import PropTypes from 'prop-types';
import {injectIntl, intlShape} from "react-intl";


class ToggleOption extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        const {intl} = this.props;

        const dropDownMenu = this.props.options.map(option => {
            return <Dropdown.Item key={option.key} value={option.value}
                                  onClick={this.props.onClickItem}>
                <Flag name={option.value==='en'?'us':'id'}/>
                {option.text}
            </Dropdown.Item>
        });

        return (
            <Dropdown item text={intl.formatMessage(this.props.inputLabel)}>
                <Dropdown.Menu>
                    {dropDownMenu}
                </Dropdown.Menu>
            </Dropdown>
        )
    }

}

ToggleOption.propTypes = {
    options: PropTypes.array.isRequired,
    onClickItem: PropTypes.func.isRequired,
    inputLabel: PropTypes.object,
    intl: intlShape
};

export default injectIntl(ToggleOption);


// WEBPACK FOOTER //
// ./src/components/ToggleOption/index.js